import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';
import { PillVariant } from './Pill';

interface ContainerProps {
  $variant: PillVariant;
}

const getColorStyles = (props: ThemeProp & ContainerProps) => {
  const getColorCSS = (backgroundColor: string, textColor: string) => {
    return `background-color: ${backgroundColor}; color: ${textColor};`;
  };
  // TODO: Define the color for each variant
  if (props.$variant) {
    switch (props.$variant) {
      case 'variant1':
        return getColorCSS(props.theme.colors.main.c100, props.theme.colors.main.c600);
      case 'variant2':
        return getColorCSS(props.theme.colors.main.c100, props.theme.colors.main.c600);
      case 'variant3':
        return getColorCSS(props.theme.colors.main.c100, props.theme.colors.main.c600);
      case 'variant4':
        return getColorCSS(props.theme.colors.main.c100, props.theme.colors.main.c600);
      default:
        return getColorCSS(props.theme.colors.main.c100, props.theme.colors.main.c600);
    }
  }
  return null;
};

export const Container = styled.div<ContainerProps>`
  padding: 0.125rem 0.25rem;
  ${(props: ThemeProp & ContainerProps) => getColorStyles(props)}
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;

export const Text = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.caption2.fontSize};
  font-style: normal;
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.caption2.lineHeight};
  letter-spacing: 1px;
  text-transform: uppercase;
`;
